import { create } from 'zustand';

/**
 * Sección activa de Operaciones según el pedido que se está viendo. El detalle de un pedido vive
 * en una ruta compartida (/operaciones/orden/:id), así que el sidebar no puede distinguir
 * Presupuestos de Ventas por la URL: depende del lifecycle_stage del pedido. Las páginas del
 * pedido escriben esta señal y el Sidebar la lee para resaltar el ítem correcto.
 *   'pedidos' = presupuesto (quotation) · 'ventas' = venta (sale/fulfilled/…) · null = fuera de un pedido
 */
export type OpsSection = 'pedidos' | 'ventas' | null;

interface OpsActiveSectionStore {
  section: OpsSection;
  setSection: (section: OpsSection) => void;
}

export const useOpsActiveSection = create<OpsActiveSectionStore>((set) => ({
  section: null,
  setSection: (section) => set({ section }),
}));
